import { 
    GET_CLINIC_LIST_REQUEST,
    GET_CLINIC_LIST_SUCCESS,
    GET_CLINIC_LIST_ERROR,
    UPDATE_CLINIC_FILTER_OPTIONS,
    UPDATE_CLINIC_SELECTION,
    GET_SYSADMIN_CLINIC_LIST_ERROR,
    UPDATE_SEARCH_CLINIC_VALUE
} from '../actions';

const initialFilterOptions = {
    filterByType: null,
    filterByArea: null,
    filterByCompany: null,
}

const initialSelection = {
    mode: 1,
    selectedClinicObjectKey: 0
}

const initialSearchValue ={
    search: '',
    results: []
}

const initialState = {
    data: [],
    typeList: [],
    zoneList: [],
    areaList: [],
    isLoaded: false,
    filterOptions: initialFilterOptions,
    selection: initialSelection,
    search: initialSearchValue
};

export default function(state = initialState, action) {
    switch(action.type) {
        case UPDATE_SEARCH_CLINIC_VALUE:
            const newSearchValue = Object.assign({}, state.search, action.payload)
            return Object.assign({}, state, { search: newSearchValue});
        case UPDATE_CLINIC_FILTER_OPTIONS:
            const newFilterOptions = Object.assign({}, state.filterOptions, action.payload)
            return Object.assign({}, state, { filterOptions: newFilterOptions});
        case UPDATE_CLINIC_SELECTION:
            const newSelection = Object.assign({}, state.selection, action.payload)
            return Object.assign({}, state, { selection: newSelection});
        case GET_CLINIC_LIST_REQUEST:
            return Object.assign({}, state, {
                data: [],
                isLoaded: false,
                typeList: [],
                zoneList: [],
                areaList: []
            });        
        case GET_CLINIC_LIST_SUCCESS:
            const clinicsList = action.payload.data.clinics;
            const newTypeList = state.typeList.slice(0);
            const newZoneList = state.zoneList.slice(0);
            const newAreaList = state.areaList.slice(0);
            clinicsList.forEach((clinic) => {
                const {t, ar, z, ts} = clinic;
                if (newTypeList.findIndex((x)=>x.value==t) === -1) { newTypeList.push({value: t, text: ts}); }
                if (newZoneList.indexOf(z) === -1) { newZoneList.push(z); }
                if (newAreaList.indexOf(ar) === -1) { newAreaList.push(ar); }
            });
            return Object.assign({}, state, {
                data: action.payload.data.clinics,
                isLoaded: true,
                typeList: newTypeList,
                zoneList: newZoneList,
                areaList: newAreaList
            });
        case GET_CLINIC_LIST_ERROR:
        case GET_SYSADMIN_CLINIC_LIST_ERROR:
            return Object.assign({}, state, {
                data: [],
                isLoaded: true,
                typeList: [],
                zoneList: [],
                areaList: []
            });
        default:
            return state;
    }
}